import { render, staticRenderFns } from "./assinaturas.vue?vue&type=template&id=2a3eb2d5&"
import script from "./assinaturas.vue?vue&type=script&lang=js&"
export * from "./assinaturas.vue?vue&type=script&lang=js&"
import style0 from "./assinaturas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports